var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuvLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 80,
    viewBox: "0 0 198 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.631 0H170.477L143.704 39.93V0H117.901L117.891 31.2922H99.5651V10.1475H81.5496V31.2922H63.0842C64.5039 28.4029 65.3037 25.1537 65.3037 21.7246C65.3137 9.72757 54.5964 0.0099975 42.6093 0H0V80H25.7336V20.4549H30.8623C36.2609 20.4549 40.6398 24.8338 40.6398 30.2324C40.6398 35.6311 36.2609 39.99 30.8623 40L47.1482 80H74.5214L61.6946 48.9678H81.5396V70.1225H99.5551V48.9678H117.891V80H143.694L197.631 0Z",
    fill: "#001957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuvLogo);
export default __webpack_public_path__ + "static/media/ruv-logo.538f498adf2854693134e7f26f548d03.svg";
export { ForwardRef as ReactComponent };